// Mock Expenses Data - İNSANET
// Günlük harcama kayıtları (20 veri, 3 aylık)

export const expenseCategories = [
    { key: 'malzeme', label: 'Malzeme', color: 'bg-info' },
    { key: 'iscilik', label: 'İşçilik', color: 'bg-success' },
    { key: 'nakliye', label: 'Nakliye', color: 'bg-warning' },
    { key: 'yemek', label: 'Yemek', color: 'bg-secondary' },
    { key: 'fatura', label: 'Fatura', color: 'bg-tertiary' },
    { key: 'diger', label: 'Diğer', color: 'bg-neutral-400' },
];

export const paymentMethods = [
    { key: 'nakit', label: 'Nakit' },
    { key: 'kart', label: 'Kart' },
    { key: 'havale', label: 'Havale' },
];

export const mockExpenses = [
    // Bugün (9 Ocak 2026)
    { id: 'exp-1', date: '2026-01-09', category: 'malzeme', description: 'Çivi, vida ve dübel', amount: 1850, paymentMethod: 'nakit', constructionId: 'c1' },
    { id: 'exp-2', date: '2026-01-09', category: 'yemek', description: 'İşçilere öğle yemeği', amount: 1200, paymentMethod: 'nakit', constructionId: 'c1' },
    { id: 'exp-3', date: '2026-01-09', category: 'nakliye', description: 'Kum teslimatı', amount: 3500, paymentMethod: 'havale', constructionId: 'c1' },

    // Bu hafta (6-8 Ocak)
    { id: 'exp-4', date: '2026-01-08', category: 'malzeme', description: 'Seramik tutkalı (50 adet)', amount: 4200, paymentMethod: 'kart', constructionId: 'c1' },
    { id: 'exp-5', date: '2026-01-08', category: 'iscilik', description: 'Günlük işçi (3 kişi)', amount: 3600, paymentMethod: 'nakit', constructionId: 'c1' },
    { id: 'exp-6', date: '2026-01-08', category: 'yemek', description: 'İşçilere öğle yemeği', amount: 1100, paymentMethod: 'nakit', constructionId: 'c1' },
    { id: 'exp-7', date: '2026-01-07', category: 'malzeme', description: 'Boya (20 teneke)', amount: 8500, paymentMethod: 'kart', constructionId: 'c1' },
    { id: 'exp-8', date: '2026-01-07', category: 'fatura', description: 'Elektrik faturası', amount: 2800, paymentMethod: 'havale', constructionId: 'c1' },
    { id: 'exp-9', date: '2026-01-06', category: 'malzeme', description: 'Alçı ve macun', amount: 3200, paymentMethod: 'nakit', constructionId: 'c2' },
    { id: 'exp-10', date: '2026-01-06', category: 'diger', description: 'Temizlik malzemesi', amount: 450, paymentMethod: 'nakit', constructionId: 'c1' },

    // Bu ay (Ocak başı)
    { id: 'exp-11', date: '2026-01-03', category: 'nakliye', description: 'Demir teslimatı nakliye', amount: 5500, paymentMethod: 'havale', constructionId: 'c1' },
    { id: 'exp-12', date: '2026-01-02', category: 'iscilik', description: 'Usta ücreti (haftalık)', amount: 12000, paymentMethod: 'havale', constructionId: 'c1' },
    { id: 'exp-13', date: '2026-01-02', category: 'malzeme', description: 'PVC boru ve ek parçaları', amount: 6700, paymentMethod: 'kart', constructionId: 'c1' },

    // Geçen ay (Aralık)
    { id: 'exp-14', date: '2025-12-28', category: 'malzeme', description: 'Elektrik kablosu (500m)', amount: 4500, paymentMethod: 'kart', constructionId: 'c1' },
    { id: 'exp-15', date: '2025-12-25', category: 'fatura', description: 'Su faturası', amount: 1800, paymentMethod: 'havale', constructionId: 'c1' },
    { id: 'exp-16', date: '2025-12-20', category: 'iscilik', description: 'Usta ücreti (haftalık)', amount: 12000, paymentMethod: 'havale', constructionId: 'c1' },
    { id: 'exp-17', date: '2025-12-15', category: 'malzeme', description: 'Çimento (50 torba)', amount: 7500, paymentMethod: 'kart', constructionId: 'c2' },

    // 2-3 ay önce (Kasım-Ekim)
    { id: 'exp-18', date: '2025-11-20', category: 'malzeme', description: 'Tuğla (5000 adet)', amount: 25000, paymentMethod: 'havale', constructionId: 'c1' },
    { id: 'exp-19', date: '2025-11-10', category: 'nakliye', description: 'Vinç kiralama', amount: 15000, paymentMethod: 'havale', constructionId: 'c1' },
    { id: 'exp-20', date: '2025-10-25', category: 'malzeme', description: 'Kalıp tahtası', amount: 18000, paymentMethod: 'kart', constructionId: 'c1' },
];

// Helper fonksiyonlar
export const getExpensesByConstructionId = (constructionId) => {
    if (!constructionId) {
        return mockExpenses;
    }
    return mockExpenses.filter(e => e.constructionId === constructionId);
};

// Tarih filtreleme
export const filterExpensesByDate = (expenses, filter) => {
    const today = new Date('2026-01-09');

    const getDateStr = (date) => date.toISOString().split('T')[0];

    switch (filter) {
        case 'today':
            return expenses.filter(e => e.date === getDateStr(today));
        case 'week': {
            const weekAgo = new Date(today);
            weekAgo.setDate(weekAgo.getDate() - 7);
            return expenses.filter(e => e.date >= getDateStr(weekAgo));
        }
        case 'month': {
            const monthAgo = new Date(today);
            monthAgo.setMonth(monthAgo.getMonth() - 1);
            return expenses.filter(e => e.date >= getDateStr(monthAgo));
        }
        case '3months': {
            const threeMonthsAgo = new Date(today);
            threeMonthsAgo.setMonth(threeMonthsAgo.getMonth() - 3);
            return expenses.filter(e => e.date >= getDateStr(threeMonthsAgo));
        }
        default:
            return expenses;
    }
};

// İstatistikler
export const getExpenseStats = (expenses) => {
    return {
        total: expenses.reduce((sum, e) => sum + e.amount, 0),
        count: expenses.length,
        byCategory: expenseCategories.map(cat => ({
            ...cat,
            total: expenses.filter(e => e.category === cat.key).reduce((sum, e) => sum + e.amount, 0),
        })),
    };
};

export default mockExpenses;
